import type { ModifiedPermissionsRequest } from "@/types/modular-permissions.types";
import { prepareCalldata } from "@/utils/prepare-calldata.util";

export async function filterSocialAccounts(
  permissionModifications: ModifiedPermissionsRequest[]
) {
  const socialPermissions = permissionModifications.filter(
    (perm) => perm.isSocialAccount === true
  );

  const regularPermissions = permissionModifications.filter(
    (perm) => perm.isSocialAccount !== true
  );

  return { regularPermissions, socialPermissions };
}
